var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCards = function SvgCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M1 8.02c-.07-.64.4-1.17 1.06-1.17h13.49c.66 0 1.13.52 1.05 1.17l-.91 7.82A1.36 1.36 0 0 1 14.36 17H3.26c-.67 0-1.26-.51-1.33-1.16L1 8.02ZM3.34 4.12h10.93M5.3 1.39h7.02",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgCards;